module.exports = __webpack_public_path__ + "static/media/AR_Brand_Latest.06260fea.svg";